export default {
  localStorageItemId: 'cconsent',
}
